const PROD_ORIGIN = 'https://cert.toyota.com';
export const environment = {
  production: true,
  envName: 'prod',
  hostname: 'cert.toyota.com',
  baseApiUrl: 'https://api.cert.toyota.com',
  projectApiPath: '/prod_createproject/',
  dashboardApiPath: '/prod_dashboard/',
  superAdminApiPath: '/prod_superadmin/',
  userApiPath: '/prod_user/',
  redirectUrl: '',
  redirectUri: PROD_ORIGIN,
  redirect_uri: PROD_ORIGIN,
  proxy: '/{proxy+}',
  postLogoutRedirectUri: PROD_ORIGIN,
  baseLoginUrl: `https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/authorize?client_id=9df85bea-e69c-4492-b50b-eebad3e49b61&response_type=code&redirect_uri=${PROD_ORIGIN}&response_mode=query&scope=openid%20profile%20email%20offline_access%20https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&claims=%7B%22access_token%22%3A%7B%22capolids%22%3A%7B%22essential%22%3Atrue%2C%22values%22%3A%5B%222d17fe5e-e439-4910-a5dd-6efa578c163f%22%5D%7D%7D%7D`,
  tokenURL: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: '9df85bea-e69c-4492-b50b-eebad3e49b61',
  redirectURI: PROD_ORIGIN,
  scopes: ['user.read', 'email', 'profile'],
  authority: 'https://login.microsoftonline.com/tmna.onmicrosoft.com/',
  graphApiUrl: 'https://graph.microsoft.com/v1.0'
};